import { databasePaths } from './paths';

// Plain data: no console, no loader (the entry chunk reads it; route.ts stays lazy).
/** Provider scopes this module serves in the service catalog. */
export const serviceScopes = [
  { scope: 'Internal.Opennebula.Database', category: 'databases', route: (id: string) => `${databasePaths.base}/${id}` },
] as const;
